import React, { FC } from 'react'
import { Box, Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { ToggleButtons } from './ToggleButtons'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const GridRow: FC = ({ children }) => {
  return (
    <Grid container spacing={4}>
      {children}
    </Grid>
  )
}

export const Settlement: FC = () => {
  const classes = useStyles()
  return (
    <Box className={classes.container}>
      <ToggleButtons />
    </Box>
  )
}
